
import { computed, defineComponent, PropType } from "vue";
import { useBookingStore } from "@/store/booking";
import { DirectionEnum, PassengerTypeEnum } from "@/models/enums";
import BaseQuantity from "@/components/base/BaseQuantity.vue";
import PetsConfirmation from "./PetsConfirmation.vue";

export default defineComponent({
	components: { 
        BaseQuantity,
        PetsConfirmation,
    },
    props: {
        type: {
            type: String as PropType<PassengerTypeEnum>,
            required: true
        },
        name: String,
        ageSuffix: String
    },
	setup(props) {
        const {
            setPassenger,
            getBooking,
        } = useBookingStore();
         
        const inputValue = computed({
            get(): number {
                return getBooking.outward.passengers.filter(p => p.type === props.type)?.length
            },
            set(value: number) {
                setPassenger(DirectionEnum.Outward, props.type, value);
            },
        });

        return { inputValue };
	},
});
